// Função para recuperar e exibir os produtos recentemente visualizados
function getRecentPdp() {
   // Verifique se a div #recent_products_block existe
  const recentProductsBlock = document.querySelector("#recent_products_block");

  if (!recentProductsBlock) {
    // Se não encontrar, retorna e não executa o restante da função
    return;
  }
  
  const pdpData = JSON.parse(localStorage.getItem("recently_viewed")); // Converte os dados armazenados no localStorage

  if (pdpData && pdpData.length > 0) {
    const recentViewHtml = []; // Array para armazenar o HTML dos produtos

    pdpData.forEach(function (item) {
      // Loop pelos produtos armazenados
      // Verifique se a URL da imagem está correta
      // Gerar HTML com dados do localStorage
      recentViewHtml.push(`
          <li class="product-card-item" data-product-id="${item.productUrl}">
              <a href="${
                item.productUrl
              }" class="product-link ${item.productImgSecond == "" ? "no-hover" : ""}">
                  <img
                    src="${item.productImg}"
                    srcset="${
                      item.productImg
                    } 400w, ${item.productImg} 800w, ${item.productImg} 1200w"
                    sizes="(max-width: 600px) 400px, (max-width: 1200px) 800px, 1200px"
                    alt="${item.productTitle}"
                    class="product-image default-image"
                    width="800"
                    height="1200"
                  >
                  ${
                    item.productImgSecond != ""
                      ? `
                  <img
                    src="${item.productImgSecond}"
                    srcset="${item.productImgSecond} 400w, ${item.productImgSecond} 800w, ${item.productImgSecond} 1200w"
                    sizes="(max-width: 600px) 400px, (max-width: 1200px) 800px, 1200px"
                    alt="${item.productTitle}"
                    class="product-image hover-image"
                    width="800"
                    height="1200"
                  >
                  `
                      : ""
                  }
              </a>
              <div class="product-info">
                  <span class="name">${item.productTitle}</span>
                  <div class="price-container">
                      ${item.productPrice !== item.productSalePrice && item.productSalePrice != undefined ? `
                      <div class="price">
                        <span class="list-price">${item.productPrice}</span>
                        <span class="sale-price">${item.productSalePrice}</span>
                      </div>
                    ` : `
                      <div class="price">
                        <span class="sale-price">${item.productPrice}</span>
                      </div>
                    `}
                      <div class="associations-variants">
                        <span class="option-association-color" title="${
                          item.color
                        }" style="${item.colorOptionBG}"></span>
                        ${
                          item.quantityAssociations > 0
                            ? `<span class="quantity-associations">+ ${item.quantityAssociations}</span>`
                            : ""
                        }
                      </div>
                  </div>
              </div>
              <div class="product-hover-options">
                <a class="ver-produto" href="${item.productUrl}">Ver Produto</a>
              </div>
          </li>
      `);
    });

    // Consolida o HTML e injeta dentro da <ul> do #recent_products_block
    const ulElement = document.querySelector("#recent_products_block ul");
    ulElement.innerHTML = recentViewHtml.join(""); // Injeta o HTML gerado na <ul>

    // Exibe o bloco de produtos recentes
    document.getElementById("recent_products_block").style.display = "block";

    setTimeout(function(){
       $("#recent_products_block ul").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 300,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    }, 500);
   
  } else {
    // Se não houver dados no localStorage, o bloco não é exibido
    document.getElementById("recent_products_block").style.display = "none";
  }
}

// Executa a função ao carregar a página
getRecentPdp();
